export const loginActions = (status) => {
  return {
    type: "LOGIN_ACTIONS",
    status: status,
  };
};
